import React from "react";
import { Link } from "react-router-dom";
import AboutImage from "../../images/post.jpg";

const SellCarSection = () => {
  return (
    <div className="relative flex flex-col md:flex-row items-center justify-between px-6 py-16 md:py-24 bg-gradient-to-r from-amber-50 to-orange-50 overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute -top-24 -left-24 w-64 h-64 rounded-full bg-amber-200 opacity-20"></div>
      <div className="absolute -bottom-24 -right-24 w-64 h-64 rounded-full bg-orange-200 opacity-20"></div>
      
      <div className="relative z-10 bg-white p-8 md:p-10 rounded-2xl shadow-lg text-center md:text-left w-full md:w-7/12 lg:w-5/12 transform transition-all duration-300 hover:shadow-xl">
        <h1 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">
          Want to Sell Your Car?
        </h1>
        <p className="text-gray-700 text-lg mb-8 leading-relaxed">
          Selling your car has never been easier! Post an ad in just a few
          simple steps and connect with potential buyers quickly.
        </p>
        
        <Link to="/create-listing">
          <button className="inline-flex items-center justify-center bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold py-4 px-8 text-xl rounded-xl hover:from-amber-600 hover:to-orange-600 transition-all duration-300 transform hover:-translate-y-1 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2">
            Post an Ad
          </button>
        </Link>
      </div>

      <div className="relative z-10 w-full md:w-2/5 mt-10 md:mt-0">
        <div className="relative">
          <img
            src={AboutImage}
            alt="Car trading"
            className="w-full rounded-2xl shadow-lg transform transition-all duration-500 hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-amber-900/20 to-transparent rounded-2xl"></div>
        </div>
        
        {/* Decorative element */}
        <div className="hidden lg:block absolute -bottom-6 -right-6 w-24 h-24 rounded-full bg-gradient-to-r from-amber-400 to-orange-500 opacity-20"></div>
      </div>
    </div>
  );
};

export default SellCarSection;